import { Link } from 'react-router-dom'

import assets from '@/assets'
import { Button } from '@/components/ui/button'

export default function Component() {
  return (
    <div className="relative h-full">
      <div className="z-10 border-b border-muted bg-muted px-8 py-4">
        <div className="flex justify-end">
          <Link to="/entrar">
            <Button>Área do usuário</Button>
          </Link>
        </div>
      </div>

      <div className="grid gap-8 p-8 [grid-template-columns:repeat(auto-fit,minmax(300px,1fr))]">
        <div>
          <div className="mb-8">
            <h1 className="text-2xl font-light">Bem-vindo</h1>
            <p className="text-lg">ao sistema interno da Multitec</p>
          </div>

          <p className="text-lg">
            Aqui você tem acesso aos seus equipamentos, chamados, relatórios e
            muito mais.
          </p>
        </div>

        <div className="flex flex-col items-stretch gap-8">
          <img src={assets.logo} className="h-[300px] object-contain" alt="" />

          <Link to="/entrar-externo">
            <Button className="w-full py-6">Já sou cliente Multitec</Button>
          </Link>

          <a
            href="https://multitecequipamentos.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <Button variant="secondary" className="w-full py-6">
              Quero me tornar um cliente Multitec
            </Button>
          </a>
        </div>
      </div>

      <img
        src={assets.logo2}
        className="absolute -bottom-24 -left-24 z-[-1] h-[600px] w-[600px] min-w-[600px] opacity-5 [filter:brightness(2)_hue-rotate(-40deg)]"
        alt=""
      />
    </div>
  )
}
